/* eslint-disable prettier/prettier */
import React, { useContext, useState, Fragment } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
  TablePagination,
  TableRow,
  TableSortLabel,
  Stack,
  styled,
  tableCellClasses
} from '@mui/material';
import { MdDownload, MdUpload, MdCircle } from 'react-icons/md';
import { HiChevronDoubleDown, HiChevronDoubleUp } from 'react-icons/hi';
import ReactLoading from 'react-loading';
import { format, getHours } from 'date-fns';
import { toast } from 'react-toastify';
import TrackingStep from './components/TrackingStep';
import Toast from '../../../../../../components/Toast';
import { options } from '../../../../../../helpers/toastOptions';
import { useAuth } from '../../../../../../hooks/Auth';
import { useIntegration } from '../../../../../../hooks/Integration';
import { useManager } from '../../../../../../hooks/Manager';
import { useModal } from '../../../../../../hooks/Modal';
import { useTracking } from '../../../../../../hooks/Tracking';
import {
  Content,
  Section,
  Title,
  ExpandBtn,
  IconButton,
  TrackingContainer,
  Line
} from './styled';
import { SearchMyCollectionsContext } from '../..';

import { tracking as trackingImg } from '../../../../../../assets/tracking';

const SearchResult = () => {
  // const [order, setOrder] = useState('asc');
  // const [orderBy, setOrderBy] = useState('protocol');
  // const [rowsPerPage, setRowsPerPage] = useState(10);

  const { token } = useAuth();
  const { getBranchDetails } = useIntegration();
  const {
    getPickupManagerParameterization,
    getPickupManagerExtensionReasonList,
    getPickupManagerCancelReasonList,
    getPickupManagerBranchDocumentation,
    getPickupManagerBranchSchedules
  } = useManager();
  const { closeModal } = useModal();
  const { findPickupById } = useTracking();

  const {
    rows,
    setRows,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    isSearching,
    totalRecords,
    totalPages,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    setIsSubmittingPagination,
    pickupDetailList,
    setPickupDetailList,
    isLoadingPickupDetails,
    setIsLoadingPickupDetails,
    setExtensionReasonList,
    setCancelReasonList,
    setOpenOtherExtensionToFill,
    setOpenOtherCancelToFill,
    setProtocolToModal,
    pickupIdToModal,
    setPickupIdToModal,
    setBranchParameterizationToModal,
    setDataToExtend,
    setDataToCancelInvoice,
    setModalMessage,
    invoiceListToModal,
    setInvoiceListToModal,
    zipToModal,
    setZipToModal,
    setDocumentListToDownload,
    setInvoiceListToDownload,
    openLoadingModal,
    setUploadConfigToModal,
    setDownloadConfigToModal,
    openDownloadDocumentsModal,
    openDownloadInvoicesModal,
    openUploadDocumentsModal,
    openUploadInvoicesModal,
    openPrintTagModal,
    openExtendPickupModal,
    openExtendPickupNoInvoiceModal,
    openChooseExtensionMethodModal,
    openCancelPickupModal,
    openCancelPickupNoInvoiceModal,
    openChooseCancelMethodModal,
    setLimitToUploadInvoice,
    setIsPickupWithDeclaration,
    setEnablePickupOnWeekends,
    setHourLimitOnWeekends,
    setEnablePickupOnHolidays,
    setHourLimitOnHolidays,
    setEnableSlotTimeToPickupSchedule,
    setSlotTimeToPickupSchedule,
    setMinuteSlotTimeToPickupSchedule
  } = useContext(SearchMyCollectionsContext);

  const handleRequestSort = (_, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);

    setPage(1);
    setIsSubmittingPagination(true);
  };

  const createSortHandler = (property) => (event) => {
    const newPickupDetailList = rows?.map((value) => {
      return { ...value, isOpen: false };
    });

    setRows(newPickupDetailList);

    handleRequestSort(event, property);
  };

  function descendingComparator(a, b, comparatorOrderBy) {
    if (b[comparatorOrderBy] < a[comparatorOrderBy]) {
      return -1;
    }
    if (b[comparatorOrderBy] > a[comparatorOrderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(comparatorOrder, comparatorOrderBy) {
    return comparatorOrder === 'desc'
      ? (a, b) => descendingComparator(a, b, comparatorOrderBy)
      : (a, b) => -descendingComparator(a, b, comparatorOrderBy);
  }

  const handleChangePage = (_, newPage) => {
    setPage(newPage + 1);

    setIsSubmittingPagination(true);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(1);

    setIsSubmittingPagination(true);
  };

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };

  const handleGetPickupData = async ({
    pickupId,
    index,
    isToDownloadDocuments = false,
    isToDownloadInvoices = false,
    isToUploadDocuments = false,
    isToUploadInvoices = false,
    isToPrintTag = false
  }) => {
    if (pickupDetailList[index]?.pickup?.pickupId === pickupId) {
      return;
    }

    setIsLoadingPickupDetails(true);

    if (isToDownloadDocuments || isToDownloadInvoices || isToPrintTag) {
      setModalMessage('Pesquisando...');
      setInvoiceListToDownload([]);
    }

    try {
      const findPickupResponse = await findPickupById({ pickupId, token });

      if (findPickupResponse?.status === 200) {
        const { pickup } = findPickupResponse.data.data;

        const newPickupDetailList = [...pickupDetailList];

        const newPickup = {
          taxInvoiceList: [],
          taxDocumentList: [],
          extensionReasonList: [],
          cancelReasonList: [],
          openOtherExtensionToFill: true,
          disableExtensionButton: true,
          openOtherCancelToFill: true,
          disableCancelButton: true,
          uploadConfig: {
            enableXmlUpload: false,
            enableMsdsUpload: false,
            enableDanfeUpload: false,
            enableFailureLetterUpload: false,
            enableDeclarationUpload: false,
            enableAuthorizationLetterUpload: false
          },
          downloadConfig: {
            enableXmlDownload: false,
            enableFispqDownload: false,
            enableDanfeDownload: false,
            enableFailureLetterDownload: false,
            enableDeclarationDownload: false,
            enableAuthorizationLetterDownload: false,
            enableTagDownload: false
          }
        };

        newPickup.pickupStatusDate = pickup?.pickupStatusDate;
        newPickup.pickupCancelType = pickup?.pickupCancelType;
        newPickup.trackingStatus =
          pickup?.trackingStatus?.length > 0
            ? pickup?.trackingStatus
              ?.slice(0)
              ?.reverse()
              ?.filter(({ pickupStatusId }) => pickupStatusId !== 1)
            : [];
        newPickup.extensions = [];
        newPickup.extensionLimit = pickup?.extensionLimit ?? 0;
        newPickup.extensionCount = pickup?.extensionCount ?? 0;
        newPickup.taxQuantity = pickup?.taxQuantity ?? 0;
        newPickup.taxInvoiceCount = pickup?.taxInvoiceCount ?? 0;
        newPickup.pickupId = pickup?.pickupId;
        newPickup.requesterCorporation = pickup?.requesterCorporation;
        newPickup.intranetOperatorDescription =
          pickup?.intranetOperatorDescription;
        newPickup.generatedTag = pickup?.generatedTag;
        newPickup.updatedAt = pickup?.updatedAt;
        newPickup.cancelledAt = pickup?.cancelledAt;
        newPickup.enablePickupOnWeekends = false;
        newPickup.hourLimitOnWeekends = 0;
        newPickup.enablePickupOnHolidays = false;
        newPickup.hourLimitOnHolidays = 0;
        newPickup.enableSlotTimeToPickupSchedule = false;
        newPickup.hourSlotTimeToPickupSchedule = 0;
        newPickup.crewData = pickup?.crewData || '';
        newPickup.fleetData = pickup?.fleetData || '';
        newPickup.routeDescription = pickup?.routeDescription || '';
        newPickup.colRouteDescription = pickup?.colRouteDescription || '';

        if (pickup?.extensions?.length > 0) {
          const extensions = pickup?.extensions?.sort((a, b) =>
            a.pickupTaxExtensionId > b.pickupTaxExtensionId ? 1 : -1
          );

          newPickup.extensions = [...extensions];
        }

        if (pickup?.extensionHistory?.length > 0) {
          newPickup.extensionHistory = pickup?.extensionHistory
            ?.reverse()
            ?.map((value) => {
              value.isProtocolOpen = false;
              return value;
            });
        } else {
          newPickup.extensionHistory = [];
        }

        let branchParameterizationId;
        let pickupManagerResponse;

        if (pickup?.shipmentList) {
          newPickup.senderCorporation =
            pickup?.shipmentList[0]?.senderCorporation;
          newPickup.receiverCorporation =
            pickup?.shipmentList[0]?.receiverCorporation;
          newPickup.shipmentAvailability =
            pickup?.shipmentList[0]?.shipmentAvailability;
          newPickup.taxInformationType =
            pickup?.shipmentList[0]?.taxInformationResponse?.taxInformationType;

          if (
            pickup?.shipmentList[0]?.taxInformationResponse?.taxInvoiceList
              ?.length > 0
          ) {
            if (
              pickup?.branchParameterizationId !== undefined &&
              pickup?.branchParameterizationId !== null &&
              pickup?.branchParameterizationId !== 0
            ) {
              branchParameterizationId = pickup?.branchParameterizationId;
            } else {
              pickupManagerResponse = await getPickupManagerParameterization({
                branchId: 1,
                transportTypeId: 9,
                pickupTypeId: 1,
                inputTypeId: 5,
                token
              });

              if (pickupManagerResponse?.length > 0) {
                branchParameterizationId =
                  pickupManagerResponse[0]?.branchParameterizationId;
              }
            }

            if (branchParameterizationId !== undefined) {
              const documentationResponse =
                await getPickupManagerBranchDocumentation({
                  branchParameterizationId
                });

              if (documentationResponse?.length > 0) {
                const {
                  enableXmlUpload,
                  enableMsdsUpload,
                  enableDanfeUpload,
                  enableFailureLetterUpload,
                  enableDeclarationUpload,
                  enableAuthorizationLetterUpload,
                  enableXmlDownload,
                  enableFispqDownload,
                  enableDanfeDownload,
                  enableFailureLetterDownload,
                  enableDeclarationDownload,
                  enableAuthorizationLetterDownload,
                  enableTagDownload
                } = documentationResponse[0];

                newPickup.uploadConfig = {
                  enableXmlUpload,
                  enableMsdsUpload,
                  enableDanfeUpload,
                  enableFailureLetterUpload,
                  enableDeclarationUpload,
                  enableAuthorizationLetterUpload
                };

                newPickup.downloadConfig = {
                  enableXmlDownload,
                  enableFispqDownload,
                  enableDanfeDownload,
                  enableFailureLetterDownload,
                  enableDeclarationDownload,
                  enableAuthorizationLetterDownload,
                  enableTagDownload
                };
              }

              const extensionReasonResponse =
                await getPickupManagerExtensionReasonList({
                  branchParameterizationId,
                  token
                });

              if (extensionReasonResponse) {
                if (extensionReasonResponse?.enableExtension) {
                  newPickup.disableExtensionButton = false;
                }

                if (
                  extensionReasonResponse?.extensionFillConfiguration === false
                ) {
                  newPickup.openOtherExtensionToFill = false;
                }

                if (extensionReasonResponse?.extensionList?.length > 0) {
                  extensionReasonResponse?.extensionList?.forEach(
                    (extensionReason) => {
                      if (
                        extensionReason.userGroupId === 1 &&
                        extensionReason.enabled
                      ) {
                        newPickup.extensionReasonList.push(extensionReason);
                      }
                    }
                  );
                }
              }

              const cancelReasonResponse =
                await getPickupManagerCancelReasonList({
                  branchParameterizationId,
                  token
                });

              if (cancelReasonResponse?.enableCancellation) {
                newPickup.disableCancelButton = false;

                if (cancelReasonResponse?.openToFill === false) {
                  newPickup.openOtherCancelToFill = false;
                }

                if (cancelReasonResponse?.cancelList?.length > 0) {
                  cancelReasonResponse?.cancelList?.forEach((cancelReason) => {
                    if (
                      cancelReason.userGroupId === 1 &&
                      cancelReason.enabled
                    ) {
                      newPickup.cancelReasonList.push(cancelReason);
                    }
                  });
                }
              }

              const scheduleResponse = await getPickupManagerBranchSchedules({
                branchParameterizationId
              });

              if (scheduleResponse?.length > 0) {
                if (
                  scheduleResponse[0]?.enablePickupOnWeekends ===
                  true
                ) {
                  const { dateEnablePickupOnWeekends } =
                    scheduleResponse[0];

                  const hour = getHours(
                    new Date(dateEnablePickupOnWeekends)
                  );

                  newPickup.hourLimitOnWeekends = hour;
                  newPickup.enablePickupOnWeekends = true;
                } else {
                  newPickup.hourLimitOnWeekends = 0;
                  newPickup.enablePickupOnWeekends = false;
                }

                if (
                  scheduleResponse[0]?.enablePickupOnHolidays ===
                  true
                ) {
                  const { dateEnablePickupOnHolidays } =
                    scheduleResponse[0];

                  const hour = getHours(
                    new Date(dateEnablePickupOnHolidays)
                  );

                  newPickup.hourLimitOnHolidays = hour;
                  newPickup.enablePickupOnHolidays = true;
                } else {
                  newPickup.hourLimitOnHolidays = 0;
                  newPickup.enablePickupOnHolidays = false;
                }

                if (
                  scheduleResponse[0]?.enableTimeSlotTimeToPickupSchedule ===
                  true
                ) {
                  const { dateEnableTimeSlotTimeToPickupSchedule } =
                    scheduleResponse[0];

                  const hour = getHours(
                    new Date(dateEnableTimeSlotTimeToPickupSchedule)
                  );

                  newPickup.slotTimeToPickupSchedule = hour;
                  newPickup.enableSlotTimeToPickupSchedule = true;
                } else {
                  newPickup.slotTimeToPickupSchedule = 0;
                  newPickup.enableSlotTimeToPickupSchedule = false;
                }
              } else {
                newPickup.hourLimitOnWeekends = 0;
                newPickup.enablePickupOnWeekends = false;
                newPickup.hourLimitOnHolidays = 0;
                newPickup.enablePickupOnHolidays = false;
                newPickup.slotTimeToPickupSchedule = 0;
                newPickup.enableSlotTimeToPickupSchedule = false;
              }
            } else {
              newPickup.hourLimitOnWeekends = 0;
              newPickup.enablePickupOnWeekends = false;
              newPickup.hourLimitOnHolidays = 0;
              newPickup.enablePickupOnHolidays = false;
              newPickup.slotTimeToPickupSchedule = 0;
              newPickup.minuteSlotTimeToPickupSchedule = 0;
              newPickup.enableSlotTimeToPickupSchedule = false;
            }

            pickup?.shipmentList[0]?.taxInformationResponse?.taxInvoiceList.forEach(
              (taxInvoice) => {
                let formattedDate = '-';
                if (taxInvoice.dateIssue) {
                  formattedDate = format(
                    new Date(taxInvoice.dateIssue),
                    'dd/MM/yyyy'
                  );
                }

                newPickup.taxInvoiceList.push({
                  ...taxInvoice,
                  formattedDate,
                  isInvoiceOpen: false
                });
              }
            );
          } else {
            if (
              pickup?.branchParameterizationId !== undefined &&
              pickup?.branchParameterizationId !== null &&
              pickup?.branchParameterizationId !== 0
            ) {
              branchParameterizationId = pickup?.branchParameterizationId;
            } else {
              pickupManagerResponse = await getPickupManagerParameterization({
                branchId: 1,
                transportTypeId: 9,
                pickupTypeId: 1,
                inputTypeId: 5,
                token
              });

              if (pickupManagerResponse?.length > 0) {
                branchParameterizationId =
                  pickupManagerResponse[0]?.branchParameterizationId;
              }
            }

            if (branchParameterizationId !== undefined) {
              const documentationResponse =
                await getPickupManagerBranchDocumentation({
                  branchParameterizationId
                });

              if (documentationResponse?.length > 0) {
                const {
                  enableXmlUpload,
                  enableMsdsUpload,
                  enableDanfeUpload,
                  enableFailureLetterUpload,
                  enableDeclarationUpload,
                  enableAuthorizationLetterUpload,
                  enableXmlDownload,
                  enableFispqDownload,
                  enableDanfeDownload,
                  enableFailureLetterDownload,
                  enableDeclarationDownload,
                  enableAuthorizationLetterDownload,
                  enableTagDownload
                } = documentationResponse[0];

                newPickup.uploadConfig = {
                  enableXmlUpload,
                  enableMsdsUpload,
                  enableDanfeUpload,
                  enableFailureLetterUpload,
                  enableDeclarationUpload,
                  enableAuthorizationLetterUpload
                };

                newPickup.downloadConfig = {
                  enableXmlDownload,
                  enableFispqDownload,
                  enableDanfeDownload,
                  enableFailureLetterDownload,
                  enableDeclarationDownload,
                  enableAuthorizationLetterDownload,
                  enableTagDownload
                };
              }

              const extensionReasonResponse =
                await getPickupManagerExtensionReasonList({
                  branchParameterizationId,
                  token
                });

              if (extensionReasonResponse) {
                if (extensionReasonResponse?.enableExtension) {
                  newPickup.disableExtensionButton = false;
                }

                if (
                  extensionReasonResponse?.extensionFillConfiguration === false
                ) {
                  newPickup.openOtherExtensionToFill = false;
                }

                if (extensionReasonResponse?.extensionList?.length > 0) {
                  extensionReasonResponse?.extensionList?.forEach(
                    (extensionReason) => {
                      if (
                        extensionReason.userGroupId === 1 &&
                        extensionReason.enabled
                      ) {
                        newPickup.extensionReasonList.push(extensionReason);
                      }
                    }
                  );
                }
              }

              const cancelReasonResponse =
                await getPickupManagerCancelReasonList({
                  branchParameterizationId,
                  token
                });

              if (cancelReasonResponse?.enableCancellation) {
                newPickup.disableCancelButton = false;

                if (cancelReasonResponse?.openToFill === false) {
                  newPickup.openOtherCancelToFill = false;
                }

                if (cancelReasonResponse?.cancelList?.length > 0) {
                  cancelReasonResponse?.cancelList?.forEach((cancelReason) => {
                    if (
                      cancelReason.userGroupId === 1 &&
                      cancelReason.enabled
                    ) {
                      newPickup.cancelReasonList.push(cancelReason);
                    }
                  });
                }
              }

              const scheduleResponse = await getPickupManagerBranchSchedules({
                branchParameterizationId
              });

              if (scheduleResponse?.length > 0) {
                if (
                  scheduleResponse[0]?.enablePickupOnWeekends ===
                  true
                ) {
                  const { dateEnablePickupOnWeekends } =
                    scheduleResponse[0];

                  const hour = getHours(
                    new Date(dateEnablePickupOnWeekends)
                  );

                  newPickup.hourLimitOnWeekends = hour;
                  newPickup.enablePickupOnWeekends = true;
                } else {
                  newPickup.hourLimitOnWeekends = 0;
                  newPickup.enablePickupOnWeekends = false;
                }

                if (
                  scheduleResponse[0]?.enablePickupOnHolidays ===
                  true
                ) {
                  const { dateEnablePickupOnHolidays } =
                    scheduleResponse[0];

                  const hour = getHours(
                    new Date(dateEnablePickupOnHolidays)
                  );

                  newPickup.hourLimitOnHolidays = hour;
                  newPickup.enablePickupOnHolidays = true;
                } else {
                  newPickup.hourLimitOnHolidays = 0;
                  newPickup.enablePickupOnHolidays = false;
                }

                if (
                  scheduleResponse[0]?.enableTimeSlotTimeToPickupSchedule ===
                  true
                ) {
                  const { dateEnableTimeSlotTimeToPickupSchedule } =
                    scheduleResponse[0];

                  const hour = getHours(
                    new Date(dateEnableTimeSlotTimeToPickupSchedule)
                  );
                  const minutes = new Date(
                    dateEnableTimeSlotTimeToPickupSchedule
                  ).getMinutes();

                  newPickup.slotTimeToPickupSchedule = hour;
                  newPickup.minuteSlotTimeToPickupSchedule = minutes;
                  newPickup.enableSlotTimeToPickupSchedule = true;
                } else {
                  newPickup.slotTimeToPickupSchedule = 0;
                  newPickup.minuteSlotTimeToPickupSchedule = 0;
                  newPickup.enableSlotTimeToPickupSchedule = false;
                }
              } else {
                newPickup.hourLimitOnWeekends = 0;
                newPickup.enablePickupOnWeekends = false;
                newPickup.hourLimitOnHolidays = 0;
                newPickup.enablePickupOnHolidays = false;
                newPickup.slotTimeToPickupSchedule = 0;
                newPickup.minuteSlotTimeToPickupSchedule = 0;
                newPickup.enableSlotTimeToPickupSchedule = false;
              }
            } else {
              newPickup.hourLimitOnWeekends = 0;
              newPickup.enablePickupOnWeekends = false;
              newPickup.hourLimitOnHolidays = 0;
              newPickup.enablePickupOnHolidays = false;
              newPickup.slotTimeToPickupSchedule = 0;
              newPickup.enableSlotTimeToPickupSchedule = false;
            }
          }

          if (
            pickup?.shipmentList[0]?.taxInformationResponse?.taxDocumentList
              ?.length > 0
          ) {
            pickup?.shipmentList[0]?.taxInformationResponse?.taxDocumentList.forEach(
              (taxDocument) => {
                newPickup.taxDocumentList.push(taxDocument);
              }
            );
          }
        }

        const isToOpenModal =
          isToDownloadDocuments ||
          isToDownloadInvoices ||
          isToUploadDocuments ||
          isToUploadInvoices ||
          isToPrintTag;

        const newIsOpen = pickupDetailList[index].isOpen;

        newPickupDetailList[index] = {
          isOpen: isToOpenModal ? newIsOpen : true,
          branchParameterizationId,
          pickup: newPickup
        };

        if (isToDownloadDocuments) {
          setModalMessage('Sem documentos');

          setDocumentListToDownload(
            newPickupDetailList[index]?.pickup?.taxDocumentList
          );
          setBranchParameterizationToModal(
            newPickupDetailList[index]?.branchParameterizationId
          );
          setDownloadConfigToModal(newPickup.downloadConfig);
        } else if (isToDownloadInvoices || isToPrintTag) {
          setModalMessage('Sem notas fiscais');

          if (newPickupDetailList[index]?.pickup?.taxInvoiceList) {
            const taxInvoiceListFiltered = newPickupDetailList[
              index
            ]?.pickup?.taxInvoiceList?.filter(
              (invoice) => invoice.typeDocument === 'XML'
            );

            setInvoiceListToDownload(taxInvoiceListFiltered);
          } else {
            setInvoiceListToDownload([]);
          }

          setDownloadConfigToModal(newPickup.downloadConfig);
        } else if (isToUploadInvoices || isToUploadDocuments) {
          if (
            isToUploadInvoices &&
            ((newPickup?.taxInformationType !== 'Declaração' &&
              newPickup?.taxQuantity > 0 &&
              newPickup?.taxQuantity - newPickup?.taxInvoiceCount <= 0) ||
              (newPickup?.taxInformationType === 'Declaração' &&
                newPickup?.taxQuantity > 0 &&
                newPickup?.taxQuantity -
                  newPickup?.taxDocumentList?.filter(
                    ({ taxDocumentTypeId, storageUrl }) =>
                      taxDocumentTypeId === 3 && !!storageUrl
                  )?.length <=
                  0))
          ) {
            toast(
              <Toast
                title="Atenção!"
                content="Limite de notas fiscais atingido."
                type="error"
              />,
              options
            );
            closeModal();
          } else {
            setUploadConfigToModal(newPickup.uploadConfig);
            setPickupIdToModal(newPickup.pickupId);

            if (newPickup?.taxQuantity > 0) {
              if (newPickup?.taxInformationType === 'Declaração') {
                setLimitToUploadInvoice(
                  newPickup?.taxQuantity -
                    newPickup?.taxDocumentList?.filter(
                      ({ taxDocumentTypeId, storageUrl }) =>
                        taxDocumentTypeId === 3 && !!storageUrl
                    )?.length
                );
              } else {
                setLimitToUploadInvoice(
                  newPickup?.taxQuantity - newPickup?.taxInvoiceCount
                );
              }
            } else {
              setLimitToUploadInvoice(999);
            }

            if (newPickup?.taxInformationType === 'Declaração') {
              setIsPickupWithDeclaration(true);
            } else {
              setIsPickupWithDeclaration(false);
            }

            if (
              isToUploadDocuments ||
              newPickup?.taxInformationType === 'Declaração'
            ) {
              openUploadDocumentsModal();
            } else {
              openUploadInvoicesModal();
            }
          }
        }

        setPickupDetailList(newPickupDetailList);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);

      toast(
        <Toast
          title="Falha ao buscar dados da coleta."
          content="Tente novamente mais tarde."
          type="error"
        />,
        options
      );

      const newPickupDetailList = [...pickupDetailList];

      newPickupDetailList[index].isOpen = false;

      setPickupDetailList(newPickupDetailList);
    } finally {
      setIsLoadingPickupDetails(false);
    }
  };

  const handleCheckAll = ({
    taxInvoiceList,
    branchParameterizationId,
    pickupId,
    protocol,
    zipSender
  }) => {
    if (taxInvoiceList?.length === 0) {
      return;
    }

    let newInvoiceListToModal = [];

    const newTaxInvoiceList = taxInvoiceList.filter(
      (value) => !value.cancelReasonId
    );

    if (newTaxInvoiceList?.length !== invoiceListToModal.length) {
      newInvoiceListToModal = [...newTaxInvoiceList];
    }

    setInvoiceListToModal(newInvoiceListToModal);

    if (newInvoiceListToModal.length > 0) {
      setPickupIdToModal(pickupId);
      setProtocolToModal(protocol);
      setBranchParameterizationToModal(branchParameterizationId);
      setZipToModal(zipSender);
    } else {
      setPickupIdToModal('');
      setProtocolToModal('');
      setBranchParameterizationToModal('');
      setZipToModal('');
    }
  };

  const handleCheck = ({
    taxInvoice,
    branchParameterizationId,
    pickupId,
    protocol,
    zipSender
  }) => {
    let newInvoiceListToModal = [...invoiceListToModal];

    if (pickupId !== pickupIdToModal) {
      newInvoiceListToModal = [];
    }

    setPickupIdToModal(pickupId);
    setProtocolToModal(protocol);
    setBranchParameterizationToModal(branchParameterizationId);
    setZipToModal(zipSender);

    const selected = newInvoiceListToModal?.filter(
      (data) => taxInvoice.taxInvoiceId === data.taxInvoiceId
    );

    if (selected?.length > 0) {
      newInvoiceListToModal = newInvoiceListToModal.filter(
        (data) => data.taxInvoiceId !== taxInvoice.taxInvoiceId
      );

      setInvoiceListToModal(newInvoiceListToModal);
    } else {
      newInvoiceListToModal.push(taxInvoice);

      setInvoiceListToModal([...newInvoiceListToModal]);
    }

    if (newInvoiceListToModal.length === 0) {
      setPickupIdToModal('');
      setProtocolToModal('');
      setBranchParameterizationToModal('');
      setZipToModal('');
    }
  };

  return (
    <Content>
      <Box>
        <Section variant="elevation" elevation={2}>
          <Title style={{ marginBottom: 16 }}>Resultado da Pesquisa:</Title>
          <TableContainer sx={{ borderRadius: '4px' }}>
            <Table size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    id="protocol"
                    sortDirection={orderBy === 'protocolo' ? order : false}
                    align="center"
                  >
                    <TableSortLabel
                      active={orderBy === 'protocolo'}
                      direction={orderBy === 'protocolo' ? order : 'asc'}
                      onClick={createSortHandler('protocolo')}
                      style={{ color: 'var(--mui-palette-white)' }}
                    >
                      <p style={{ paddingLeft: '32px' }}>Protocolo</p>
                      {orderBy === 'protocolo' ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc'
                            ? 'sorted descending'
                            : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </StyledTableCell>
                  <StyledTableCell
                    id="createdAt"
                    sortDirection={orderBy === 'data' ? order : false}
                    align="center"
                  >
                    <TableSortLabel
                      active={orderBy === 'data'}
                      direction={orderBy === 'data' ? order : 'asc'}
                      onClick={createSortHandler('data')}
                      style={{ color: 'var(--mui-palette-white)' }}
                    >
                      <p style={{ paddingLeft: '32px' }}>Data da Solicitação</p>
                      {orderBy === 'data' ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc'
                            ? 'sorted descending'
                            : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </StyledTableCell>
                  <StyledTableCell
                    id="modal"
                    sortDirection={orderBy === 'modal' ? order : false}
                    align="center"
                  >
                    <TableSortLabel
                      active={orderBy === 'modal'}
                      direction={orderBy === 'modal' ? order : 'asc'}
                      onClick={createSortHandler('modal')}
                      style={{ color: 'var(--mui-palette-white)' }}
                    >
                      <p style={{ paddingLeft: '32px' }}>Tipo de Modal</p>
                      {orderBy === 'modal' ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc'
                            ? 'sorted descending'
                            : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </StyledTableCell>
                  <StyledTableCell
                    id="pickupStatus"
                    sortDirection={orderBy === 'status' ? order : false}
                    align="center"
                  >
                    <TableSortLabel
                      active={orderBy === 'status'}
                      direction={orderBy === 'status' ? order : 'asc'}
                      onClick={createSortHandler('status')}
                      style={{ color: 'var(--mui-palette-white)' }}
                    >
                      <p style={{ paddingLeft: '32px' }}>Status</p>
                      {orderBy === 'status' ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === 'desc'
                            ? 'sorted descending'
                            : 'sorted ascending'}
                        </Box>
                      ) : null}
                    </TableSortLabel>
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ padding: 6 }}>
                    Documentos Fiscais
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ padding: 6 }}>
                    Outros Documentos
                  </StyledTableCell>
                  <StyledTableCell align="center" style={{ padding: 6 }}>
                    Impressão de Etiquetas
                  </StyledTableCell>
                  <StyledTableCell align="center"> </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {rows?.length === 0 && (
                  <StyledTableRow>
                    <StyledTableCell colSpan={8} align="center">
                      {isSearching ? 'Pesquisando...' : 'Sem resultados'}
                    </StyledTableCell>
                  </StyledTableRow>
                )}
                {rows?.map((row, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <Fragment key={`${row.pickupId}-${index}`}>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        {row.protocol}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.formattedCreatedAt}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {row.modal}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="center"
                        >
                          <Stack>
                            <MdCircle
                              size={16}
                              style={{
                                // eslint-disable-next-line prettier/prettier
                                color: row.pickupStatus.toLowerCase() === 'cancelada' ? '#aaaaaa' : row.extensionCount >= row.extensionLimit && row.pickupStatus.toLowerCase() === 'prorrogada' ? '#c2b1db' : '#8ec97b'
                              }}
                            />
                          </Stack>
                          <p style={{ whiteSpace: 'nowrap' }}>
                            {row.pickupStatus}
                          </p>
                        </Stack>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Stack
                          spacing={1}
                          direction="row"
                          justifyContent="center"
                        >
                          <IconButton
                            type="button"
                            disabled={!!isLoadingPickupDetails}
                            onClick={() => {
                              if (
                                !pickupDetailList[index]?.pickup?.pickupId
                              ) {
                                handleGetPickupData({
                                  pickupId: row.pickupId,
                                  index,
                                  isToDownloadInvoices: true
                                });
                                setProtocolToModal(row.protocol);
                                openDownloadInvoicesModal();
                              } else {
                                setModalMessage('Sem notas fiscais');
                                setProtocolToModal(row.protocol);
                                setInvoiceListToDownload(
                                  pickupDetailList[index]?.pickup
                                    ?.taxInvoiceList
                                );
                                setDownloadConfigToModal(
                                  pickupDetailList[index]?.pickup
                                    ?.downloadConfig
                                );
                                openDownloadInvoicesModal();
                              }
                            }}
                          >
                            <MdDownload style={{ fontSize: '20px' }} />
                          </IconButton>
                          <IconButton
                            type="button"
                            disabled={
                              !!isLoadingPickupDetails ||
                              row.pickupStatus?.toLowerCase() ===
                                'cancelada' ||
                              row.pickupStatus?.toLowerCase() ===
                                'coletada' ||
                              row.pickupStatus?.toLowerCase() === 'prorrogada'
                            }
                            onClick={() => {
                              setProtocolToModal(row.protocol);
                              if (
                                !pickupDetailList[index]?.pickup?.pickupId
                              ) {
                                openLoadingModal();
                                handleGetPickupData({
                                  pickupId: row.pickupId,
                                  index,
                                  isToUploadInvoices: true
                                });
                              } else if (
                                (pickupDetailList[index]?.pickup
                                  ?.taxInformationType !== 'Declaração' &&
                                  pickupDetailList[index]?.pickup
                                    ?.taxQuantity > 0 &&
                                  pickupDetailList[index]?.pickup
                                    ?.taxQuantity -
                                    pickupDetailList[index]?.pickup
                                      ?.taxInvoiceCount <=
                                    0) ||
                                (pickupDetailList[index]?.pickup
                                  ?.taxInformationType === 'Declaração' &&
                                  pickupDetailList[index]?.pickup
                                    ?.taxQuantity > 0 &&
                                  pickupDetailList[index]?.pickup
                                    ?.taxQuantity -
                                    pickupDetailList[
                                      index
                                    ]?.pickup?.taxDocumentList?.filter(
                                      ({ taxDocumentTypeId, storageUrl }) =>
                                        taxDocumentTypeId === 3 &&
                                        !!storageUrl
                                    )?.length <=
                                    0)
                              ) {
                                toast(
                                  <Toast
                                    title="Atenção!"
                                    content="Limite de notas fiscais atingido."
                                    type="error"
                                  />,
                                  options
                                );
                              } else {
                                setUploadConfigToModal(
                                  pickupDetailList[index]?.pickup
                                    ?.uploadConfig
                                );
                                setPickupIdToModal(
                                  pickupDetailList[index]?.pickup?.pickupId
                                );

                                if (
                                  pickupDetailList[index]?.pickup
                                    ?.taxQuantity > 0
                                ) {
                                  if (
                                    pickupDetailList[index]?.pickup
                                      ?.taxInformationType === 'Declaração'
                                  ) {
                                    setLimitToUploadInvoice(
                                      pickupDetailList[index]?.pickup
                                        ?.taxQuantity -
                                        pickupDetailList[
                                          index
                                        ]?.pickup?.taxDocumentList?.filter(
                                          ({
                                            taxDocumentTypeId,
                                            storageUrl
                                          }) =>
                                            taxDocumentTypeId === 3 &&
                                            !!storageUrl
                                        )?.length
                                    );
                                  } else {
                                    setLimitToUploadInvoice(
                                      pickupDetailList[index]?.pickup
                                        ?.taxQuantity -
                                        pickupDetailList[index]?.pickup
                                          ?.taxInvoiceCount
                                    );
                                  }
                                } else {
                                  setLimitToUploadInvoice(999);
                                }

                                if (
                                  pickupDetailList[index]?.pickup
                                    ?.taxInformationType === 'Declaração'
                                ) {
                                  setIsPickupWithDeclaration(true);
                                  openUploadDocumentsModal();
                                } else {
                                  openUploadInvoicesModal();
                                }
                              }
                            }}
                          >
                            <MdUpload style={{ fontSize: '20px' }} />
                          </IconButton>
                        </Stack>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Stack
                          spacing={1}
                          direction="row"
                          justifyContent="center"
                        >
                          <IconButton
                            type="button"
                            disabled={!!isLoadingPickupDetails}
                            onClick={async () => {
                              if (
                                !pickupDetailList[index]?.pickup?.pickupId
                              ) {
                                setProtocolToModal(row.protocol);
                                openDownloadDocumentsModal();
                                await handleGetPickupData({
                                  pickupId: row.pickupId,
                                  index,
                                  isToDownloadDocuments: true
                                });
                              } else {
                                setModalMessage('Sem documentos');
                                setDocumentListToDownload(
                                  pickupDetailList[index]?.pickup
                                    ?.taxDocumentList
                                );
                                setDownloadConfigToModal(
                                  pickupDetailList[index]?.pickup
                                    ?.downloadConfig
                                );
                                setProtocolToModal(row.protocol);
                                openDownloadDocumentsModal();
                              }
                            }}
                          >
                            <MdDownload style={{ fontSize: '20px' }} />
                          </IconButton>
                          <IconButton
                            type="button"
                            disabled={!!isLoadingPickupDetails}
                            onClick={async () => {
                              setProtocolToModal(row.protocol);
                              if (
                                !pickupDetailList[index]?.pickup?.pickupId
                              ) {
                                openLoadingModal();
                                await handleGetPickupData({
                                  pickupId: row.pickupId,
                                  index,
                                  isToUploadDocuments: true
                                });
                              } else {
                                setPickupIdToModal(
                                  pickupDetailList[index]?.pickup?.pickupId
                                );
                                setBranchParameterizationToModal(
                                  pickupDetailList[index]
                                    ?.branchParameterizationId
                                );
                                setUploadConfigToModal(
                                  pickupDetailList[index]?.pickup
                                    ?.uploadConfig
                                );

                                if (
                                  pickupDetailList[index]?.pickup
                                    ?.taxQuantity > 0
                                ) {
                                  if (
                                    pickupDetailList[index]?.pickup
                                      ?.taxInformationType === 'Declaração'
                                  ) {
                                    setIsPickupWithDeclaration(true);
                                    setLimitToUploadInvoice(
                                      pickupDetailList[index]?.pickup
                                        ?.taxQuantity -
                                        pickupDetailList[
                                          index
                                        ]?.pickup?.taxDocumentList?.filter(
                                          ({
                                            taxDocumentTypeId,
                                            storageUrl
                                          }) =>
                                            taxDocumentTypeId === 3 &&
                                            !!storageUrl
                                        )?.length
                                    );
                                  } else {
                                    setLimitToUploadInvoice(0);
                                  }
                                } else if (
                                  pickupDetailList[index]?.pickup
                                    ?.taxInformationType === 'Declaração'
                                ) {
                                  setIsPickupWithDeclaration(true);
                                  setLimitToUploadInvoice(999);
                                } else {
                                  setIsPickupWithDeclaration(false);
                                  setLimitToUploadInvoice(0);
                                }

                                openUploadDocumentsModal();
                              }
                            }}
                          >
                            <MdUpload style={{ fontSize: '20px' }} />
                          </IconButton>
                        </Stack>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Stack justifyContent="center">
                          <IconButton
                            type="button"
                            disabled={
                              !(
                                row.pickupRequestStatus?.toLowerCase() ===
                                  'programada (aguardando impressão da etiqueta)' ||
                                row.pickupRequestStatus?.toLowerCase() ===
                                  'programada'
                              )
                            }
                            onClick={() => {
                              if (
                                !pickupDetailList[index]?.pickup?.pickupId
                              ) {
                                setPickupIdToModal(row?.pickupId);
                                setProtocolToModal(row?.protocol);
                                handleGetPickupData({
                                  pickupId: row.pickupId,
                                  index,
                                  isToPrintTag: true
                                });
                                openPrintTagModal();
                              } else {
                                setModalMessage('Sem notas fiscais');
                                setPickupIdToModal(row?.pickupId);
                                setProtocolToModal(row?.protocol);

                                if (
                                  pickupDetailList[index]?.pickup
                                    ?.taxInvoiceList?.length > 0
                                ) {
                                  const taxInvoiceListFiltered =
                                    pickupDetailList[
                                      index
                                    ]?.pickup?.taxInvoiceList?.filter(
                                      (invoice) =>
                                        invoice.typeDocument === 'XML'
                                    );

                                  setInvoiceListToDownload(
                                    taxInvoiceListFiltered
                                  );
                                } else {
                                  setInvoiceListToDownload([]);
                                }

                                setDownloadConfigToModal(
                                  pickupDetailList[index]?.pickup
                                    ?.downloadConfig
                                );
                                openPrintTagModal();
                              }
                            }}
                          >
                            <MdDownload
                              style={{
                                fontSize: '20px',
                                color:
                                  isLoadingPickupDetails ||
                                  !(
                                    row.pickupRequestStatus?.toLowerCase() ===
                                      'programada (aguardando impressão da etiqueta)' ||
                                    row.pickupRequestStatus?.toLowerCase() ===
                                      'programada'
                                  )
                                    ? '#cccccc'
                                    : '#000000'
                              }}
                            />
                          </IconButton>
                        </Stack>
                      </StyledTableCell>
                      <StyledTableCell align="center" style={{ padding: 6 }}>
                        {!pickupDetailList[index]?.isOpen ? (
                          <ExpandBtn
                            type="button"
                            disabled={!!isLoadingPickupDetails}
                            onClick={(event) => {
                              const newPickupDetailList = [
                                ...pickupDetailList
                              ];
                              newPickupDetailList[index] = {
                                isOpen: !pickupDetailList[index].isOpen,
                                pickup: pickupDetailList[index].pickup
                              };
                              handleGetPickupData({
                                pickupId: row.pickupId,
                                index
                              });

                              setInvoiceListToModal([]);
                              setPickupIdToModal('');
                              setProtocolToModal('');
                              setBranchParameterizationToModal('');
                              setZipToModal('');

                              setPickupDetailList(newPickupDetailList);
                              event.preventDefault();
                            }}
                          >
                            <i
                              className="far fa-plus-square"
                              style={{
                                fontSize: '21px',
                                color: isLoadingPickupDetails
                                  ? '#cccccc'
                                  : '#444444'
                              }}
                            />
                          </ExpandBtn>
                        ) : (
                          <ExpandBtn
                            type="button"
                            disabled={!!isLoadingPickupDetails}
                            onClick={(event) => {
                              const newPickupDetailList = [
                                ...pickupDetailList
                              ];
                              newPickupDetailList[index] = {
                                isOpen: !pickupDetailList[index].isOpen,
                                pickup: pickupDetailList[index].pickup
                              };
                              setPickupDetailList(newPickupDetailList);
                              event.preventDefault();
                            }}
                          >
                            <i
                              className="far fa-minus-square"
                              style={{
                                fontSize: '21px',
                                color: isLoadingPickupDetails
                                  ? '#cccccc'
                                  : '#444444'
                              }}
                            />
                          </ExpandBtn>
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                    {pickupDetailList[index]?.isOpen &&
                      (!isLoadingPickupDetails &&
                      pickupDetailList[index]?.pickup?.pickupId ? (
                        <StyledTableRow
                          style={{
                            backgroundColor:
                              row.pickupStatus.toLowerCase() === 'cancelada'
                                ? '#cccccc'
                                : '#aed39d'
                          }}
                        >
                          <StyledTableCell colSpan={8}>
                            <Stack spacing={2} style={{ padding: 8 }}>
                              <Stack
                                direction="row"
                                style={{ justifyContent: 'space-between' }}
                              >
                                <p>Status: {row.pickupStatus}</p>
                                <p>
                                  Filial: {row.branchSenderInitials || '-'}
                                </p>
                                <p>Conhecimento: {row.knowledgeId || '-'}</p>
                              </Stack>

                              {/* eslint-disable-next-line prettier/prettier */}
                              {pickupDetailList[index]?.pickup?.senderCorporation?.name && (
                                <Stack>
                                  <p>Dados da Coleta:</p>
                                  <p>
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation.name
                                    }{' '}
                                    -{' '}
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation.document
                                    }
                                  </p>
                                  <p>
                                    Endereço de Coleta:{' '}
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation?.address
                                        ?.streetAddress
                                    }
                                    ,{' '}
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation?.address
                                        ?.streetAddressNumber
                                    }
                                    {pickupDetailList[index]?.pickup
                                      ?.senderCorporation?.address
                                      ?.additionalInformation && (
                                      <>
                                        ,{' '}
                                        {
                                          pickupDetailList[index]?.pickup
                                            ?.senderCorporation?.address
                                            ?.additionalInformation
                                        }
                                      </>
                                    )}
                                    ,{' '}
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation?.address?.suburb
                                    }
                                    ,{' '}
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation?.address?.city
                                    }
                                    ,{' '}
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation?.address?.state
                                    }
                                    , CEP{' '}
                                    {
                                      pickupDetailList[index]?.pickup
                                        ?.senderCorporation?.address
                                        ?.zipPostalCode
                                    }
                                  </p>
                                </Stack>
                              )}
                              <Stack>
                                <p>Protocolo: {row.protocol}</p>
                                <p>
                                  Dados da Tripulação:{' '}
                                  {pickupDetailList[index]?.pickup?.crewData || 'Tripulação a confirmar'}
                                </p>
                                <p>
                                  Dados da Frota:{' '}
                                  {pickupDetailList[index]?.pickup?.fleetData || 'Frota a confirmar'}
                                </p>
                                <p>
                                  Rota da coleta:{' '}
                                  {pickupDetailList[index]?.pickup?.routeDescription ? (
                                    <>
                                      {pickupDetailList[index]?.pickup?.routeDescription}
                                      {pickupDetailList[index]?.pickup
                                        ?.colRouteDescription
                                        ? ` - ${pickupDetailList[index]?.pickup?.colRouteDescription}`
                                        : ''}
                                    </>
                                  ) : (
                                    'Rota a confirmar'
                                  )}
                                </p>
                              </Stack>

                              {pickupDetailList[index]?.pickup
                                ?.taxInvoiceCount === 0 && (
                                <Stack direction="row" gap={2}>
                                  <p>Situação: {row?.pickupStatus}</p>
                                  <p>
                                    {row?.pickupStatus === 'Prorrogada'
                                      ? `Para: ${
                                        pickupDetailList[index]?.pickup
                                          ?.extensions?.length > 0 &&
                                        pickupDetailList[
                                          index
                                        ]?.pickup?.extensions.slice(-1)[0]
                                          ?.dateTo
                                          ? format(
                                            new Date(
                                              pickupDetailList[
                                                index
                                              ]?.pickup?.extensions.slice(
                                                -1
                                              )[0]?.dateTo
                                            ),
                                            'dd/MM/yyyy'
                                          )
                                          : '-'
                                      }`
                                      : row.pickupStatus === 'Programada' ||
                                        row.pickupStatus === 'Coleta Parcial'
                                        ? `Para: ${
                                          pickupDetailList[index]?.pickup
                                            ?.shipmentAvailability
                                            ?.pickupUntilDate
                                            ? format(
                                              new Date(
                                                pickupDetailList[
                                                  index
                                                ]?.pickup?.shipmentAvailability?.pickupUntilDate
                                              ),
                                              'dd/MM/yyyy'
                                            )
                                            : '-'
                                        }`
                                        : row.pickupStatus === 'Coletada'
                                          ? `Em: ${
                                            pickupDetailList[index]?.pickup
                                              ?.updatedAt
                                              ? format(
                                                new Date(
                                                  pickupDetailList[
                                                    index
                                                  ]?.pickup?.updatedAt
                                                ),
                                                'dd/MM/yyyy'
                                              )
                                              : '-'
                                          }`
                                          : row.pickupStatus === 'Cancelada'
                                            ? `Em: ${
                                              pickupDetailList[index]?.pickup
                                                ?.cancelledAt
                                                ? format(
                                                  new Date(
                                                    pickupDetailList[
                                                      index
                                                    ]?.pickup?.cancelledAt
                                                  ),
                                                  'dd/MM/yyyy'
                                                )
                                                : '-'
                                            }`
                                            : `Em: ${
                                              pickupDetailList[index]?.pickup
                                                ?.pickupStatusDate
                                                ? format(
                                                  new Date(
                                                    pickupDetailList[
                                                      index
                                                    ]?.pickup?.pickupStatusDate
                                                  ),
                                                  'dd/MM/yyyy'
                                                )
                                                : '-'
                                            }`}
                                  </p>
                                </Stack>
                              )}
                              <TrackingContainer>
                                {pickupDetailList[
                                  index
                                ]?.pickup?.trackingStatus
                                  ?.map((tracking, trackingIndex) => {
                                    let trackingDescription = '';

                                    // only show first "Coleta Parcial" tracking register
                                    if (tracking.pickupStatusId === 9) {
                                      const alreadyShowTrackingStatusIndex =
                                        pickupDetailList[
                                          index
                                        ]?.pickup?.trackingStatus?.findIndex(
                                          (value) => value.pickupStatusId === 9
                                        );

                                      if (
                                        alreadyShowTrackingStatusIndex <
                                        trackingIndex
                                      ) {
                                        return null;
                                      }
                                    }

                                    // only show last "Em Rota" tracking register
                                    if (tracking.pickupStatusId === 5) {
                                      const onRouteTrackingList =
                                        pickupDetailList[
                                          index
                                        ]?.pickup?.trackingStatus?.filter(
                                          (value) => value.pickupStatusId === 5
                                        );

                                      if (onRouteTrackingList?.length > 1) {
                                        const onRouteTrackingIndex =
                                          onRouteTrackingList?.findIndex(
                                            ({ pickupStatusEvolutionId }) =>
                                              pickupStatusEvolutionId ===
                                              tracking.pickupStatusEvolutionId
                                          );

                                        if (
                                          onRouteTrackingIndex <
                                          onRouteTrackingList?.length - 1
                                        ) {
                                          return null;
                                        }
                                      }
                                    }

                                    if (tracking.pickupStatusId === 7) {
                                      const extensionList =
                                        pickupDetailList[index]?.pickup
                                          ?.extensions;

                                      if (extensionList?.length > 0) {
                                        const trackingExtensionList =
                                          pickupDetailList[
                                            index
                                          ]?.pickup?.trackingStatus.filter(
                                            ({ pickupStatusId }) =>
                                              pickupStatusId === 7
                                          );

                                        const trackingExtensionIndex =
                                          trackingExtensionList?.findIndex(
                                            ({ pickupStatusEvolutionId }) =>
                                              pickupStatusEvolutionId ===
                                              tracking.pickupStatusEvolutionId
                                          );

                                        if (trackingExtensionIndex >= 0) {
                                          trackingDescription =
                                            extensionList[
                                              trackingExtensionIndex
                                            ]?.extensionReasonDescription;
                                        }
                                      }
                                    } else if (
                                      tracking.pickupStatusId === 8
                                    ) {
                                      trackingDescription =
                                        pickupDetailList[index]?.pickup
                                          ?.pickupCancelType;
                                    }

                                    return (
                                      <Stack
                                        key={tracking.pickupStatusEvolutionId}
                                        direction="row"
                                        style={{ alignItems: 'flex-start' }}
                                      >
                                        <Line />
                                        <TrackingStep
                                          stepTitle={
                                            tracking?.statusDescription ===
                                            'Registrada'
                                              ? 'Solicitação Registrada'
                                              : tracking?.statusDescription
                                          }
                                          hourText={new Date(
                                            tracking?.createdAt
                                          ).toLocaleString('pt-br')}
                                          icon={() =>
                                            tracking.pickupStatusId === 2 ? (
                                              <img
                                                src={trackingImg.Icone_Solicitada}
                                                alt={tracking.statusDescription}
                                                style={{ width: 96 }}
                                              />
                                            ) : tracking.pickupStatusId ===
                                              3 ? (
                                                <img
                                                  src={trackingImg.Icone_Agendada}
                                                  alt={tracking.statusDescription}
                                                  style={{ width: 96 }}
                                                />
                                              ) : tracking.pickupStatusId ===
                                              4 ? (
                                                <img
                                                  src={trackingImg.Icone_Programada}
                                                  alt={tracking.statusDescription}
                                                  style={{ width: 96 }}
                                                />
                                                ) : tracking.pickupStatusId ===
                                              5 ? (
                                                <img
                                                  src={
                                                    trackingImg.Icone_Em_Rota
                                                  }
                                                  alt={
                                                    tracking.statusDescription
                                                  }
                                                  style={{ width: 96 }}
                                                />
                                                  ) : tracking.pickupStatusId ===
                                              6 ? (
                                                <img
                                                  src={
                                                    trackingImg.Icone_Coletada
                                                  }
                                                  alt={
                                                    tracking.statusDescription
                                                  }
                                                  style={{ width: 96 }}
                                                />
                                                    ) : tracking.pickupStatusId ===
                                              7 ? (
                                                <img
                                                  src={
                                                    trackingImg.Icone_Prorrogada
                                                  }
                                                  alt={
                                                    tracking.statusDescription
                                                  }
                                                  style={{ width: 96 }}
                                                />
                                                      ) : tracking.pickupStatusId ===
                                              8 ? (
                                                <img
                                                  src={
                                                    trackingImg.Icone_Cancelada
                                                  }
                                                  alt={
                                                    tracking.statusDescription
                                                  }
                                                  style={{ width: 96 }}
                                                />
                                                        ) : tracking.pickupStatusId ===
                                              9 ? (
                                                <img
                                                  src={
                                                    trackingImg.Icone_Coleta_Parcial
                                                  }
                                                  alt={
                                                    tracking.statusDescription
                                                  }
                                                  style={{ width: 96 }}
                                                />
                                                          ) : tracking.pickupStatusId ===
                                                  10 ? (
                                                    <img
                                                      src={
                                                      trackingImg.Icone_Programada
                                                    }
                                                      alt={tracking.statusDescription}
                                                      style={{ width: 96 }}
                                                    />
                                                            ) : (
                                                              tracking.pickupStatusId ===
                                                11 && (
                                                <img
                                                  src={trackingImg.Icone_Programada}
                                                  alt={tracking.statusDescription}
                                                  style={{ width: 96 }}
                                                />
                                                              )
                                                            )}
                                          toolTipContent={
                                            tracking.pickupStatusId === 2 ? (
                                              <>
                                                <p>Solicitação Registrada</p>
                                                <p>
                                                  {new Date(
                                                    tracking?.createdAt
                                                  ).toLocaleString('pt-br')}
                                                </p>
                                              </>
                                            ) : tracking.pickupStatusId ===
                                              7 ? (
                                                <>
                                                  <p>Detalhes da Prorrogação</p>
                                                  <p>
                                                    Prorrogado por:{' '}
                                                    {
                                                      tracking?.createdByDescription
                                                    }
                                                  </p>
                                                  <p>
                                                    Motivo:{' '}
                                                    {tracking?.extensionReason
                                                      ? tracking?.extensionReason
                                                      : trackingDescription}
                                                  </p>
                                                  <p>
                                                    {new Date(
                                                      tracking?.createdAt
                                                    ).toLocaleString('pt-br')}
                                                  </p>
                                                </>
                                              ) : (
                                                tracking.pickupStatusId ===
                                                8 && (
                                                <>
                                                  <p>
                                                    Detalhes do Cancelamento
                                                  </p>
                                                  <p>
                                                    Cancelado por:{' '}
                                                    {
                                                      tracking?.createdByDescription
                                                    }
                                                  </p>
                                                  <p>
                                                    Motivo:{' '}
                                                    {trackingDescription}
                                                  </p>
                                                  <p>
                                                    {new Date(
                                                      tracking?.createdAt
                                                    ).toLocaleString('pt-br')}
                                                  </p>
                                                </>
                                                )
                                              )
                                          }
                                        />
                                      </Stack>
                                    );
                                  })}
                              </TrackingContainer>

                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                style={{
                                  alignItems: 'center',
                                  marginTop: '8px',
                                  marginBottom: '-8px'
                                }}
                              >
                                <Stack
                                  direction="row"
                                  style={{
                                    alignItems: 'center',
                                    marginTop: '8px',
                                    marginBottom: '8px'
                                  }}
                                >
                                  {pickupDetailList[index]?.pickup
                                    ?.intranetOperatorDescription ? (
                                      <Stack>
                                        Dados do Solicitante:{' '}
                                        {
                                          pickupDetailList[index]?.pickup
                                            ?.intranetOperatorDescription
                                        }
                                      </Stack>
                                    ) : (
                                      pickupDetailList[index]?.pickup
                                        ?.requesterCorporation && (
                                        <Stack>
                                          Dados do Solicitante:{' '}
                                          {
                                            pickupDetailList[index]?.pickup
                                              ?.requesterCorporation.name
                                          }
                                        </Stack>
                                      )
                                    )}
                                </Stack>

                                {pickupDetailList[index]?.pickup
                                  ?.taxInvoiceList?.length > 1 && (
                                  <Stack
                                    direction="column"
                                    style={{
                                      alignItems: 'center'
                                      // marginBottom: '-8px'
                                    }}
                                  >
                                    <label>Selecionar todos</label>
                                    <Checkbox
                                      disabled={
                                        pickupDetailList[index]?.pickup
                                          ?.taxInvoiceList?.length === 0 ||
                                        (pickupDetailList[index]?.pickup
                                          ?.disableCancelButton &&
                                          pickupDetailList[index]?.pickup
                                            ?.disableExtensionButton) ||
                                        row.pickupStatus.toLowerCase() ===
                                          'cancelada'
                                      }
                                      checked={
                                        pickupDetailList[index]?.pickup
                                          ?.taxInvoiceList?.length > 0 &&
                                        pickupIdToModal === row.pickupId &&
                                        invoiceListToModal.length ===
                                          pickupDetailList[
                                            index
                                          ]?.pickup?.taxInvoiceList?.filter(
                                            (value) => !value.cancelReasonId
                                          )?.length &&
                                        row.pickupStatus.toLowerCase() !==
                                          'cancelada'
                                      }
                                      onChange={() => {
                                        handleCheckAll({
                                          taxInvoiceList:
                                            pickupDetailList[index]?.pickup
                                              ?.taxInvoiceList,
                                          branchParameterizationId:
                                            pickupDetailList[index]
                                              ?.branchParameterizationId,
                                          pickupId: row.pickupId,
                                          protocol: row.protocol,
                                          zipSender:
                                            pickupDetailList[index]?.pickup
                                              ?.senderCorporation?.address
                                              ?.zipPostalCode
                                        });
                                      }}
                                    />
                                  </Stack>
                                )}

                                {pickupDetailList[index]?.pickup
                                  ?.taxInvoiceList?.length === 0 && (
                                  <Stack
                                    spacing={1}
                                    direction="row"
                                    style={{
                                      marginTop: '8px',
                                      marginBottom: '8px'
                                    }}
                                  >
                                    <Button
                                      type="button"
                                      variant="contained"
                                      disabled={
                                        pickupDetailList[index]?.pickup
                                          ?.disableExtensionButton ||
                                        !(
                                          row.pickupStatus.toLowerCase() ===
                                            'programada' ||
                                          row.pickupStatus.toLowerCase() ===
                                            'prorrogada' ||
                                          row.pickupStatus.toLowerCase() ===
                                            'coleta parcial'
                                        )
                                      }
                                      onClick={() => {
                                        setProtocolToModal(row.protocol);
                                        setPickupIdToModal(row.pickupId);
                                        setBranchParameterizationToModal(
                                          pickupDetailList[index]
                                            ?.branchParameterizationId
                                        );
                                        setZipToModal(
                                          pickupDetailList[index]?.pickup
                                            ?.senderCorporation?.address
                                            ?.zipPostalCode
                                        );

                                        setOpenOtherExtensionToFill(
                                          pickupDetailList[index]?.pickup
                                            ?.openOtherExtensionToFill
                                        );

                                        if (
                                          pickupDetailList[index]?.pickup
                                            ?.extensionReasonList?.length > 0
                                        ) {
                                          setExtensionReasonList(
                                            pickupDetailList[index]?.pickup
                                              ?.extensionReasonList
                                          );
                                        }

                                        setHourLimitOnWeekends(
                                          pickupDetailList[index]?.pickup
                                            ?.hourLimitOnWeekends
                                        );
                                        setEnablePickupOnWeekends(
                                          pickupDetailList[index]?.pickup
                                            ?.enablePickupOnWeekends
                                        );
                                        setHourLimitOnHolidays(
                                          pickupDetailList[index]?.pickup
                                            ?.hourLimitOnHolidays
                                        );
                                        setEnablePickupOnHolidays(
                                          pickupDetailList[index]?.pickup
                                            ?.enablePickupOnHolidays
                                        );
                                        setSlotTimeToPickupSchedule(
                                          pickupDetailList[index]?.pickup
                                            ?.slotTimeToPickupSchedule
                                        );
                                        setMinuteSlotTimeToPickupSchedule(
                                          pickupDetailList[index]?.pickup
                                            ?.minuteSlotTimeToPickupSchedule
                                        );
                                        setMinuteSlotTimeToPickupSchedule(
                                          pickupDetailList[index]?.pickup
                                            ?.minuteSlotTimeToPickupSchedule
                                        );
                                        setEnableSlotTimeToPickupSchedule(
                                          pickupDetailList[index]?.pickup
                                            ?.enableSlotTimeToPickupSchedule
                                        );

                                        openExtendPickupNoInvoiceModal();
                                      }}
                                    >
                                      Prorrogar
                                    </Button>

                                    <Button
                                      type="button"
                                      variant="contained"
                                      color="secondary"
                                      disabled={
                                        pickupDetailList[index]?.pickup
                                          ?.disableCancelButton ||
                                        !(
                                          row.pickupStatus.toLowerCase() ===
                                            'programada' ||
                                          row.pickupStatus.toLowerCase() ===
                                            'prorrogada' ||
                                          row.pickupStatus.toLowerCase() ===
                                            'coleta parcial'
                                        )
                                      }
                                      onClick={() => {
                                        setProtocolToModal(row.protocol);
                                        setPickupIdToModal(row.pickupId);
                                        setBranchParameterizationToModal(
                                          pickupDetailList[index]
                                            ?.branchParameterizationId
                                        );
                                        setZipToModal(
                                          pickupDetailList[index]?.pickup
                                            ?.senderCorporation?.address
                                            ?.zipPostalCode
                                        );

                                        setOpenOtherCancelToFill(
                                          pickupDetailList[index]?.pickup
                                            ?.openOtherCancelToFill
                                        );

                                        if (
                                          pickupDetailList[index]?.pickup
                                            ?.cancelReasonList?.length > 0
                                        ) {
                                          setCancelReasonList(
                                            pickupDetailList[index]?.pickup
                                              ?.cancelReasonList
                                          );
                                        }

                                        openCancelPickupNoInvoiceModal();
                                      }}
                                    >
                                      Cancelar
                                    </Button>
                                  </Stack>
                                )}
                              </Stack>

                              {/* eslint-disable-next-line prettier/prettier */}
                              {pickupDetailList[index]?.pickup?.taxInvoiceList
                                .length > 0 && (
                                <>
                                  <Divider
                                    orientation="horizontal"
                                    flexItem
                                    style={{ marginBottom: -8 }}
                                  />

                                  <Stack
                                    spacing={1}
                                    divider={
                                      // eslint-disable-next-line react/jsx-wrap-multilines
                                      <Divider
                                        orientation="horizontal"
                                        flexItem
                                      />
                                    }
                                  >
                                    {pickupDetailList[
                                      index
                                    ]?.pickup?.taxInvoiceList?.map(
                                      (taxInvoice, invoiceIndex) => (
                                        <div
                                          key={taxInvoice.taxInvoiceId}
                                          style={{
                                            paddingLeft: '8px',
                                            // eslint-disable-next-line prettier/prettier
                                            backgroundColor:
                                              row.pickupStatus.toLowerCase() ===
                                              'cancelada'
                                                ? '#cccccc'
                                                : pickupDetailList[index]
                                                  ?.pickup
                                                  ?.extensionCount >=
                                                  pickupDetailList[index]
                                                    ?.pickup?.extensionLimit
                                                  ? '#c2b1db'
                                                  : '#aed39d'
                                          }}
                                        >
                                          <Stack
                                            spacing={2}
                                            direction="row"
                                            style={{ alignItems: 'center' }}
                                          >
                                            <span>
                                              NF: {taxInvoice?.number}
                                            </span>
                                            <ExpandBtn
                                              type="button"
                                              onClick={(event) => {
                                                event.preventDefault();

                                                const newPickupDetailList = [
                                                  ...pickupDetailList
                                                ];

                                                // eslint-disable-next-line prettier/prettier
                                                const newValue =
                                                  !newPickupDetailList[index]
                                                    .pickup.taxInvoiceList[
                                                      invoiceIndex
                                                    ].isInvoiceOpen;

                                                newPickupDetailList[
                                                  index
                                                ].pickup.taxInvoiceList[
                                                  invoiceIndex
                                                ].isInvoiceOpen = newValue;

                                                setPickupDetailList(
                                                  newPickupDetailList
                                                );
                                              }}
                                            >
                                              {taxInvoice.isInvoiceOpen ? (
                                                <HiChevronDoubleUp />
                                              ) : (
                                                <HiChevronDoubleDown />
                                              )}
                                            </ExpandBtn>

                                            <p>
                                              Situação:{' '}
                                              {taxInvoice.cancelReasonId
                                                ? 'Cancelada'
                                                : String(row.pickupStatus)}
                                            </p>

                                            <p>
                                              {row.pickupStatus !==
                                                'Cancelada' && (
                                                <>
                                                  {taxInvoice.cancelReasonId ? (
                                                    <>
                                                      Em:{' '}
                                                      {taxInvoice.cancelledAt
                                                        ? format(
                                                          new Date(
                                                            taxInvoice.cancelledAt
                                                          ),
                                                          'dd/MM/yyyy'
                                                        )
                                                        : '-'}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {taxInvoice
                                                        .pickupTaxExtensionList
                                                        ?.length > 0
                                                        ? `Para: ${format(
                                                          new Date(
                                                            taxInvoice.pickupTaxExtensionList
                                                              ?.sort(
                                                                (a, b) =>
                                                                  a.created_At >
                                                                  b.created_At
                                                                    ? 1
                                                                    : -1
                                                              )
                                                              .slice(
                                                                -1
                                                              )[0]?.dateTo
                                                          ),
                                                          'dd/MM/yyyy'
                                                        )}`
                                                        : row?.pickupStatus ===
                                                            'Registrada' ||
                                                          row?.pickupStatus ===
                                                            'Pré Coleta'
                                                          ? `Em: ${format(
                                                            new Date(
                                                              row?.createdAt
                                                            ),
                                                            'dd/MM/yyyy'
                                                          )}`
                                                          : row.pickupStatus ===
                                                          'Coletada'
                                                            ? `Em: ${format(
                                                              new Date(
                                                                pickupDetailList[
                                                                  index
                                                                ]?.pickup?.updatedAt
                                                              ),
                                                              'dd/MM/yyyy'
                                                            )}`
                                                            : `Para: ${format(
                                                              new Date(
                                                                pickupDetailList[
                                                                  index
                                                                ]?.pickup?.shipmentAvailability?.pickupUntilDate
                                                              ),
                                                              'dd/MM/yyyy'
                                                            )}`}
                                                    </>
                                                  )}
                                                </>
                                              )}

                                              {row.pickupStatus ===
                                                'Cancelada' && (
                                                <>
                                                  {taxInvoice.cancelReasonId ? (
                                                    <>
                                                      Em:{' '}
                                                      {taxInvoice.cancelledAt
                                                        ? format(
                                                          new Date(
                                                            taxInvoice.cancelledAt
                                                          ),
                                                          'dd/MM/yyyy'
                                                        )
                                                        : '-'}
                                                    </>
                                                  ) : pickupDetailList[index]
                                                    ?.pickup
                                                    .pickupStatusDate ? (
                                                      <>
                                                        Em:{' '}
                                                        {format(
                                                          new Date(
                                                            pickupDetailList[
                                                              index
                                                            ]?.pickup?.pickupStatusDate
                                                          ),
                                                          'dd/MM/yyyy'
                                                        )}
                                                      </>
                                                    ) : (
                                                      <>Em: -</>
                                                    )}
                                                </>
                                              )}
                                            </p>
                                            <p>
                                              Conhecimento:{' '}
                                              {row.knowledgeId || '-'}
                                            </p>

                                            <Stack
                                              style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                gap: 8,
                                                marginLeft: 'auto'
                                              }}
                                            >
                                              <Checkbox
                                                style={{
                                                  marginRight: '32px'
                                                }}
                                                // name={row.taxInvoiceId}
                                                disabled={
                                                  !!taxInvoice.cancelReasonId
                                                }
                                                checked={
                                                  !!invoiceListToModal.find(
                                                    (value) =>
                                                      taxInvoice.taxInvoiceId ===
                                                      value.taxInvoiceId
                                                  )
                                                }
                                                onChange={() => {
                                                  handleCheck({
                                                    taxInvoice,
                                                    branchParameterizationId:
                                                      pickupDetailList[index]
                                                        ?.branchParameterizationId,
                                                    pickupId: row.pickupId,
                                                    protocol: row.protocol,
                                                    zipSender:
                                                      pickupDetailList[index]
                                                        ?.pickup
                                                        ?.senderCorporation
                                                        ?.address
                                                        ?.zipPostalCode
                                                  });
                                                }}
                                              />
                                            </Stack>
                                          </Stack>

                                          {taxInvoice.isInvoiceOpen && (
                                            <Stack spacing={2}>
                                              <Stack spacing={1}>
                                                {pickupDetailList[index]
                                                  ?.pickup
                                                  ?.receiverCorporation
                                                  ?.name && (
                                                  <div>
                                                    <p>Destinatário:</p>
                                                    <p>
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          .name
                                                      }{' '}
                                                      -{' '}
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          .document
                                                      }
                                                    </p>
                                                    <p>
                                                      Endereço:{' '}
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          ?.address
                                                          ?.streetAddress
                                                      }
                                                      ,{' '}
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          ?.address
                                                          ?.streetAddressNumber
                                                      }
                                                      {pickupDetailList[index]
                                                        ?.pickup
                                                        ?.receiverCorporation
                                                        ?.address
                                                        ?.additionalInformation && (
                                                        <>
                                                          ,{' '}
                                                          {
                                                            pickupDetailList[
                                                              index
                                                            ]?.pickup
                                                              ?.receiverCorporation
                                                              ?.address
                                                              ?.additionalInformation
                                                          }
                                                        </>
                                                      )}
                                                      ,{' '}
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          ?.address?.suburb
                                                      }
                                                      ,{' '}
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          ?.address?.city
                                                      }
                                                      ,{' '}
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          ?.address?.state
                                                      }
                                                      , CEP{' '}
                                                      {
                                                        pickupDetailList[
                                                          index
                                                        ]?.pickup
                                                          ?.receiverCorporation
                                                          ?.address
                                                          ?.zipPostalCode
                                                      }
                                                    </p>
                                                  </div>
                                                )}
                                              </Stack>

                                              <Stack>
                                                <p>
                                                  Etiqueta:{' '}
                                                  {row.generatedTag
                                                    ? 'Cliente'
                                                    : 'Aguardando impressão'}
                                                </p>
                                              </Stack>
                                            </Stack>
                                          )}
                                        </div>
                                      )
                                    )}
                                  </Stack>

                                  <Stack
                                    spacing={1}
                                    direction="row"
                                    style={{ marginLeft: 'auto' }}
                                  >
                                    {pickupDetailList[index]?.pickup
                                      ?.taxInvoiceList?.length > 0 && (
                                      <Button
                                        type="button"
                                        variant="contained"
                                        disabled={
                                          pickupIdToModal !== row.pickupId ||
                                          pickupDetailList[index]?.pickup
                                            ?.disableExtensionButton ||
                                          !(
                                            row.pickupStatus.toLowerCase() ===
                                              'programada' ||
                                            row.pickupStatus.toLowerCase() ===
                                              'prorrogada' ||
                                            row.pickupStatus.toLowerCase() ===
                                              'coleta parcial'
                                          )
                                        }
                                        onClick={() => {
                                          const compareAllExtendList = [
                                            ...invoiceListToModal
                                          ];

                                          const invoiceListToModalFiltered =
                                            invoiceListToModal.filter(
                                              (value) =>
                                                !(
                                                  value.extensionCount >=
                                                    pickupDetailList[index]
                                                      ?.pickup
                                                      ?.extensionLimit ||
                                                  pickupDetailList[index]
                                                    ?.pickup
                                                    ?.extensionCount >=
                                                    pickupDetailList[index]
                                                      ?.pickup?.extensionLimit
                                                )
                                            );

                                          if (
                                            invoiceListToModalFiltered?.length ===
                                            0
                                          ) {
                                            toast(
                                              <Toast
                                                title="Atenção!"
                                                content="Notas selecionadas atingiram o limite de prorrogação."
                                                type="error"
                                              />,
                                              options
                                            );

                                            return;
                                          }

                                          setInvoiceListToModal(
                                            invoiceListToModalFiltered
                                          );

                                          if (
                                            invoiceListToModalFiltered?.length <
                                            compareAllExtendList?.length
                                          ) {
                                            toast(
                                              <Toast
                                                title="Atenção!"
                                                content="Uma ou mais notas selecionadas atingiram o limite de prorrogação."
                                                type="error"
                                              />,
                                              options
                                            );
                                          }

                                          setProtocolToModal(row.protocol);

                                          setOpenOtherExtensionToFill(
                                            pickupDetailList[index]?.pickup
                                              ?.openOtherExtensionToFill
                                          );

                                          if (
                                            pickupDetailList[index]?.pickup
                                              ?.extensionReasonList?.length >
                                            0
                                          ) {
                                            setExtensionReasonList(
                                              pickupDetailList[index]?.pickup
                                                ?.extensionReasonList
                                            );
                                          }

                                          setHourLimitOnWeekends(
                                            pickupDetailList[index]?.pickup
                                              ?.hourLimitOnWeekends
                                          );
                                          setEnablePickupOnWeekends(
                                            pickupDetailList[index]?.pickup
                                              ?.enablePickupOnWeekends
                                          );
                                          setHourLimitOnHolidays(
                                            pickupDetailList[index]?.pickup
                                              ?.hourLimitOnHolidays
                                          );
                                          setEnablePickupOnHolidays(
                                            pickupDetailList[index]?.pickup
                                              ?.enablePickupOnHolidays
                                          );
                                          setSlotTimeToPickupSchedule(
                                            pickupDetailList[index]?.pickup
                                              ?.slotTimeToPickupSchedule
                                          );
                                          setEnableSlotTimeToPickupSchedule(
                                            pickupDetailList[index]?.pickup
                                              ?.enableSlotTimeToPickupSchedule
                                          );

                                          if (
                                            invoiceListToModal?.length > 1
                                          ) {
                                            openChooseExtensionMethodModal();
                                          } else {
                                            openExtendPickupModal();
                                          }
                                        }}
                                      >
                                        Prorrogar
                                      </Button>
                                    )}

                                    {pickupDetailList[index]?.pickup
                                      ?.taxInvoiceList?.length > 0 && (
                                      <Button
                                        type="button"
                                        variant="contained"
                                        color="secondary"
                                        disabled={
                                          pickupIdToModal !== row.pickupId ||
                                          pickupDetailList[index]?.pickup
                                            ?.disableCancelButton ||
                                          !(
                                            row.pickupStatus.toLowerCase() ===
                                              'programada' ||
                                            row.pickupStatus.toLowerCase() ===
                                              'prorrogada' ||
                                            row.pickupStatus.toLowerCase() ===
                                              'coleta parcial'
                                          )
                                        }
                                        onClick={() => {
                                          setProtocolToModal(row.protocol);

                                          setOpenOtherCancelToFill(
                                            pickupDetailList[index]?.pickup
                                              ?.openOtherCancelToFill
                                          );

                                          if (
                                            pickupDetailList[index]?.pickup
                                              ?.cancelReasonList?.length > 0
                                          ) {
                                            setCancelReasonList(
                                              pickupDetailList[index]?.pickup
                                                ?.cancelReasonList
                                            );
                                          }

                                          // setDataToCancelInvoice({
                                          //   number: taxInvoice.number,
                                          //   taxInvoiceId: taxInvoice.taxInvoiceId
                                          // });

                                          if (
                                            invoiceListToModal?.length > 1
                                          ) {
                                            openChooseCancelMethodModal();
                                          } else {
                                            openCancelPickupModal();
                                          }
                                        }}
                                      >
                                        Cancelar
                                      </Button>
                                    )}
                                  </Stack>
                                </>
                              )}
                            </Stack>

                            {pickupDetailList[index]?.pickup?.extensionHistory
                              ?.length > 0 && (
                              <Stack
                                spacing={2}
                                style={{
                                  backgroundColor: '#bbbbbb',
                                  padding: '8px',
                                  marginTop: '8px'
                                }}
                              >
                                <span>Histórico</span>
                                <Stack
                                  spacing={2}
                                  divider={
                                    // eslint-disable-next-line react/jsx-wrap-multilines
                                    <Divider
                                      orientation="horizontal"
                                      flexItem
                                    />
                                  }
                                >
                                  {pickupDetailList[
                                    index
                                  ]?.pickup?.extensionHistory?.map(
                                    (value, protocolIndex) => (
                                      <Stack key={value.protocol} spacing={2}>
                                        <Stack
                                          spacing={2}
                                          direction="row"
                                          style={{ alignItems: 'center' }}
                                        >
                                          <span>{value.protocol}</span>

                                          <ExpandBtn
                                            type="button"
                                            onClick={(event) => {
                                              event.preventDefault();

                                              const newPickupDetailList = [
                                                ...pickupDetailList
                                              ];

                                              // eslint-disable-next-line prettier/prettier
                                              const newValue =
                                                !newPickupDetailList[index]
                                                  .pickup.extensionHistory[
                                                    protocolIndex
                                                  ].isProtocolOpen;

                                              newPickupDetailList[
                                                index
                                              ].pickup.extensionHistory[
                                                protocolIndex
                                              ].isProtocolOpen = newValue;

                                              setPickupDetailList(
                                                newPickupDetailList
                                              );
                                            }}
                                          >
                                            {value.isProtocolOpen ? (
                                              <HiChevronDoubleUp />
                                            ) : (
                                              <HiChevronDoubleDown />
                                            )}
                                          </ExpandBtn>

                                          <span>Status: {value.status}</span>
                                        </Stack>

                                        {value.isProtocolOpen && (
                                          <Stack spacing={1}>
                                            {value.invoices?.map(
                                              (invoice) => (
                                                <Stack
                                                  direction="row"
                                                  spacing={2}
                                                  style={{
                                                    paddingLeft: '16px'
                                                  }}
                                                >
                                                  <span
                                                    style={{ marginTop: -1 }}
                                                  >
                                                    ●
                                                  </span>
                                                  <span>
                                                    NF: {invoice.number}
                                                  </span>
                                                  <span>
                                                    Situação: {invoice.status}
                                                  </span>
                                                  <span>
                                                    {value?.status ===
                                                    'Prorrogada'
                                                      ? `Para: ${
                                                        invoice.date
                                                          ? format(
                                                            new Date(
                                                              invoice.date
                                                            ),
                                                            'dd/MM/yyyy'
                                                          )
                                                          : '-'
                                                      }`
                                                      : value.status ===
                                                          'Programada' ||
                                                        value.status ===
                                                          'Coleta Parcial'
                                                        ? `Para: ${
                                                          invoice.date
                                                            ? format(
                                                              new Date(
                                                                invoice.date
                                                              ),
                                                              'dd/MM/yyyy'
                                                            )
                                                            : '-'
                                                        }`
                                                        : value.status ===
                                                        'Coletada'
                                                          ? `Em: ${
                                                            invoice.date
                                                              ? format(
                                                                new Date(
                                                                  invoice.date
                                                                ),
                                                                'dd/MM/yyyy'
                                                              )
                                                              : '-'
                                                          }`
                                                          : value.status ===
                                                        'Cancelada'
                                                            ? `Em: ${
                                                              invoice.date
                                                                ? format(
                                                                  new Date(
                                                                    invoice.date
                                                                  ),
                                                                  'dd/MM/yyyy'
                                                                )
                                                                : '-'
                                                            }`
                                                            : `Em: ${
                                                              invoice.date
                                                                ? format(
                                                                  new Date(
                                                                    invoice.date
                                                                  ),
                                                                  'dd/MM/yyyy'
                                                                )
                                                                : '-'
                                                            }`}
                                                  </span>
                                                </Stack>
                                              )
                                            )}
                                          </Stack>
                                        )}
                                      </Stack>
                                    )
                                  )}
                                </Stack>
                              </Stack>
                            )}
                          </StyledTableCell>
                        </StyledTableRow>
                        ) : (
                          <StyledTableRow>
                            <StyledTableCell colSpan={8}>
                              <Box
                                style={{
                                  padding: 20,
                                  width: '100%',
                                  display: 'flex',
                                  justifyContent: 'center'
                                }}
                              >
                                <ReactLoading
                                  type="spin"
                                  color="#808080"
                                  width={40}
                                  height={40}
                                />
                              </Box>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                  </Fragment>
                ))}
              </TableBody>
              {!isSearching && (
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      count={totalRecords}
                      rowsPerPage={rowsPerPage}
                      page={page - 1}
                      labelDisplayedRows={() => {
                        // eslint-disable-next-line prettier/prettier
                        return `Página ${page} de ${totalPages}`;
                      }}
                      labelRowsPerPage="Itens por página:"
                      onPageChange={(event, newPage) => {
                        !isSearching && handleChangePage(event, newPage);
                      }}
                      onRowsPerPageChange={(event) => {
                        !isSearching && handleChangeRowsPerPage(event);
                      }}
                      showFirstButton={totalPages > 2}
                      showLastButton={totalPages > 2}
                    />
                  </TableRow>
                </TableFooter>
              )}
            </Table>
          </TableContainer>
        </Section>
      </Box>
    </Content>
  );
};

export default SearchResult;
